import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button, Props as ButtonProps } from '../../../Button/Button';

const StyledButton = styled(Button)`
  width: 100%;
  justify-content: space-between;
  height: 36px;
  cursor: default;
  font-weight: 400;
  padding: 0 12px;

  &:not(.disabled):hover,
  &:not(.disabled):focus,
  &:not(.disabled):active {
    background: ${({ theme }) => theme.colors.bg};
  }

  &:not(.disabled):not(:focus):hover {
    box-shadow: ${({ theme }) =>
      `${theme.shadows['300']}, inset 0 0 0 1px ${theme.colors.neutral['400']}`};
  }
`;

export const Trigger = forwardRef<HTMLButtonElement, ButtonProps>(({ children, ...rest }, ref) => {
  return (
    <StyledButton ref={ref} variant="secondary" rightIcon="fas fa-caret-down" {...rest}>
      {children}
    </StyledButton>
  );
});
